import { render, staticRenderFns } from "./AccountDoc.vue?vue&type=template&id=55f61430&"
import script from "./AccountDoc.vue?vue&type=script&lang=js&"
export * from "./AccountDoc.vue?vue&type=script&lang=js&"
import style0 from "./AccountDoc.vue?vue&type=style&index=0&id=55f61430&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports